import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

export interface ContactSubmissionPayload {
  fullname: string;
  email: string;
  phone: string;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class ContactApi {

  readonly #http = inject(HttpClient);
  readonly #baseUrl = environment.url;

  submitContact(payload: { data: ContactSubmissionPayload }): Observable<unknown> {
    return this.#http.post(`${this.#baseUrl}/feedback-submissions`, payload);
  }
}
